<div class="goal-row" [ngClass]="{ 'district-goal-row': type == 'district' }">
  <p class="name-text">{{ name }}</p>
  <goal-row-inputs
    [goalValue]="goal && goal.goal != null ? goal.goal : null"
    [goalInactive]="goal && goal.inactive ? goal.inactive : null"
    [id]="id"
    [metric]="metric"
    (goalValueChanged)="goalValueChanged.emit($event)"
    (goalInactiveChecked)="goalInactiveChecked.emit($event)"
    class="goal-row-inputs"
  ></goal-row-inputs>
</div>
<p
  class="goal-error"
  *ngIf="!goal || (goal && goal.goal == null && !goal.inactive)"
>
  Goal cannot be blank unless it is inactive!
</p>
